import React from 'react';
import DossierEditorLayout from './DossierEditorLayout';
import DossierAutoSave from './DossierAutoSave';
import DossierKeyboardShortcuts from './DossierKeyboardShortcuts';

/**
 * Composant éditeur principal.
 *
 * Compose le layout visible (DossierEditorLayout) et les composants
 * effect-only (auto-save 20 s, raccourcis Cmd+Z / Cmd+Y). Ces deux
 * derniers retournent `null` — ils n'altèrent pas le rendu, ils
 * branchent des `useEffect` ciblés sur le ctx.
 */
const DossierEditor: React.FC = () => (
  <>
    <DossierAutoSave />
    <DossierKeyboardShortcuts />
    <DossierEditorLayout />
  </>
);

export default DossierEditor;
